import { ProductionHoursHolidaysResponse } from 'components/WorkingHours/utils/productionHoursApiTypes';

export const HOLIDAYS_OPEN_MODAL = 'HOLIDAYS/OPEN_MODAL' as const;
export const HOLIDAYS_CLOSE_MODAL = 'HOLIDAYS/CLOSE_MODAL' as const;
export const HOLIDAYS_SET_FROM_API = 'HOLIDAYS/SET_FROM_API' as const;
export const HOLIDAYS_SET_CALENDAR_MONTH = 'HOLIDAYS/SET_CALENDAR_MONTH' as const;
export const HOLIDAYS_START_DRAG = 'HOLIDAYS/START_DRAG' as const;
export const HOLIDAYS_HOVER_DRAG = 'HOLIDAYS/HOVER_DRAG' as const;
export const HOLIDAYS_FINALIZE_DRAG = 'HOLIDAYS/FINALIZE_DRAG' as const;
export const HOLIDAYS_UPDATE_NAME = 'HOLIDAYS/UPDATE_NAME' as const;
export const HOLIDAYS_UPDATE_REPEAT = 'HOLIDAYS/UPDATE_REPEAT' as const;
export const HOLIDAYS_REQUEST_DELETE = 'HOLIDAYS/REQUEST_DELETE' as const;
export const HOLIDAYS_CANCEL_DELETE = 'HOLIDAYS/CANCEL_DELETE' as const;
export const HOLIDAYS_DISCARD_DRAFT = 'HOLIDAYS/DISCARD_DRAFT' as const;

export const openHolidaysModal = (payload: { sites: string[] }) => ({
  type: HOLIDAYS_OPEN_MODAL,
  payload,
});

export const closeHolidaysModal = () => ({
  type: HOLIDAYS_CLOSE_MODAL,
});

// Syncs local state with a GET/POST/DELETE /api/production-hours/holidays response —
// the server is always the source of truth for the holiday lists of the sites it covers.
export const setHolidaysFromApi = (payload: { response: ProductionHoursHolidaysResponse }) => ({
  type: HOLIDAYS_SET_FROM_API,
  payload,
});

export const setHolidaysCalendarMonth = (payload: { year: number; month: number }) => ({
  type: HOLIDAYS_SET_CALENDAR_MONTH,
  payload,
});

export const startHolidaysDrag = (payload: { dateKey: string }) => ({
  type: HOLIDAYS_START_DRAG,
  payload,
});

export const hoverHolidaysDrag = (payload: { dateKey: string }) => ({
  type: HOLIDAYS_HOVER_DRAG,
  payload,
});

export const finalizeHolidaysDrag = () => ({
  type: HOLIDAYS_FINALIZE_DRAG,
});

export const updateHolidayName = (payload: { id: string; name: string }) => ({
  type: HOLIDAYS_UPDATE_NAME,
  payload,
});

export const updateHolidayRepeat = (payload: { id: string; repeat: boolean }) => ({
  type: HOLIDAYS_UPDATE_REPEAT,
  payload,
});

// Opens the "are you sure?" confirm popup for a given draft item — the actual DELETE
// request only fires once the user confirms (see confirmDeleteHolidayRequest thunk).
export const requestDeleteHoliday = (payload: { id: string }) => ({
  type: HOLIDAYS_REQUEST_DELETE,
  payload,
});

export const cancelDeleteHoliday = () => ({
  type: HOLIDAYS_CANCEL_DELETE,
});

// Removes a draft item that was never saved to the server — purely local, no request.
export const discardDraftHoliday = (payload: { id: string }) => ({
  type: HOLIDAYS_DISCARD_DRAFT,
  payload,
});

export type HolidaysAction =
  | ReturnType<typeof openHolidaysModal>
  | ReturnType<typeof closeHolidaysModal>
  | ReturnType<typeof setHolidaysFromApi>
  | ReturnType<typeof setHolidaysCalendarMonth>
  | ReturnType<typeof startHolidaysDrag>
  | ReturnType<typeof hoverHolidaysDrag>
  | ReturnType<typeof finalizeHolidaysDrag>
  | ReturnType<typeof updateHolidayName>
  | ReturnType<typeof updateHolidayRepeat>
  | ReturnType<typeof requestDeleteHoliday>
  | ReturnType<typeof cancelDeleteHoliday>
  | ReturnType<typeof discardDraftHoliday>;
